import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'cx_foundations-order_list_page_issue_unrelated_button-click';
/**
 * Event that tracks the &quot;My issue is unrelated to this order&quot; button clicks on the orders list page for self-service
 */
export function trackCxFoundationsOrderListPageIssueUnrelatedButtonClick(retailerbrand_token) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { retailerbrand_token },
    });
}
